import { Box, Button, Typography } from "@dealer-center/core-components";
import { useLeadManagerHello } from "@dealer-center/ddc-pages-lead-manager-fetch";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SECTIONS, type SectionKey } from "./hashConfig";
import { SectionGroup } from "./SectionGroup";
import { SECTION_CONFIG, isMasterDetail } from "./sectionConfig";

const SECTION_KEYS = Object.values(SECTIONS) as SectionKey[];
const MASTER_DETAIL_KEYS = SECTION_KEYS.filter(k =>
  isMasterDetail(SECTION_CONFIG[k])
);
const SINGLE_KEYS = SECTION_KEYS.filter(
  k => !isMasterDetail(SECTION_CONFIG[k])
);

export const DemoNav = () => {
  const { asAccount, asUser } = useParams<{
    asAccount?: string;
    asUser?: string;
  }>();
  const navigate = useNavigate();
  const [isHelloEnabled, setIsHelloEnabled] = useState(false);
  const { data, error, isFetching } = useLeadManagerHello(isHelloEnabled);

  const handleSelect = (section: SectionKey) => {
    const base =
      asAccount && asUser
        ? `/cc/as/${asAccount}/${asUser}/leadManager`
        : `/cc/leadManager`;
    navigate(`${base}/${section}`);
  };

  const handleCallHello = () => {
    setIsHelloEnabled(true);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 3 }}>
      <SectionGroup
        keys={MASTER_DETAIL_KEYS}
        title="Master–Detail"
        onSelect={handleSelect}
      />
      <SectionGroup
        keys={SINGLE_KEYS}
        title="Single Layout"
        onSelect={handleSelect}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Button
          analyticsConfiguration={{ eventName: "lead_manager_hello_api_call" }}
          buttonStyle="secondary"
          disabled={isFetching}
          size="sm"
          onClick={handleCallHello}
        >
          {isFetching ? "Calling…" : "Call Hello API"}
        </Button>
        {error && (
          <Typography sx={{ color: "error.main" }} variant="body-sm">
            Error: {error.message}
          </Typography>
        )}
        {data && !isFetching && (
          <Typography
            sx={{
              fontSize: "0.75rem",
              overflowX: "auto",
              whiteSpace: "pre-wrap"
            }}
            variant="body-sm"
          >
            {JSON.stringify(data, null, 2)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
